<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="title-section form-section mb-0">
          <h1 class="page-title text-center">APPLICATION</h1>
          <h2 class="form-title text-center">Real Estate Errors & Omissions Insurance</h2>
        </article>
        <article class="input-section form-section" >
          <div style="border: 2px solid black;" class="p-2">
            <p class="mt-1 mb-1">
              <strong>NOTICE:</strong> This is an application for a “Claims-made” policy. Coverage for prior acts and claims made after termination of
              this policy may be restricted. Please read the policy carefully.
            </p>
          </div>
        </article>
        <article class="form-heading title-section form-section flex">
          <h1 class="form-title">PART 1: APPLICANT INFORMATION</h1>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">1.</span>Name of Applicant / Business Name:
          </label>
          <input
            type="text"
            name="nameOfApplicant"
            v-model="standardApplication.nameOfApplicant"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('nameOfApplicant')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('nameOfApplicant') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            Contact:
          </label>
          <input
            type="text"
            name="nameOfPrimaryLicensed"
            v-model="standardApplication.nameOfPrimaryLicensed"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('nameOfPrimaryLicensed')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('nameOfPrimaryLicensed') | filterText }}</span>
        </article>
        <article class="form-section">
          <div class="input-section" >
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  Principal Street Address:
                </label>
                <input
                  type="text"
                  name="address"
                  v-model="standardApplication.customer.address"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('address')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('address') | filterText }}</span>
              </div>
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  City:
                </label>
                <input
                  type="text"
                  name="city"
                  v-model="standardApplication.customer.city"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('city')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('city') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  State:
                </label>
                <select
                  class="orep-select w-100"
                  style="height: 40px; width: 383px;"
                  name="state"
                  v-model="standardApplication.customer.state"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                  v-show="errors.has('state')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('state') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  ZIP Code:
                </label>
                <input
                    type="text"
                    name="zipCode"
                    v-model="standardApplication.customer.zipCode"
                    class="orep-text-input w-100"
                    v-validate="'required|numeric|length:5'"
                    maxlength="5"
                    inputmode="numeric"
                    @keypress="!/^\d$/.test($event.key) ? ($event.preventDefault(), zipCodeError = 'Please enter numeric values only') : (zipCodeError = '')"
                    @input="validateBeforeSubmit()"
                >
                <span v-if="zipCodeError" class="text-danger small">{{ zipCodeError }}</span>
                <span
                  v-show="errors.has('zipCode')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('zipCode') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  County:
                </label>
                <input
                  type="text"
                  name="county"
                  v-model="standardApplication.customer.county"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('county')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('county') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <label for class="orep-label mb-0 ml-1">
                  Mailing Address:
                </label>
                <input
                  type="text"
                  name="mailingAddress"
                  v-model="standardApplication.mailingAddress"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('mailingAddress')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingAddress') | filterText }}</span>
              </div>
            </div>

            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Phone:
                </label>
                <input
                  type="text"
                  name="phone"
                  v-model="standardApplication.customer.phone"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('phone')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('phone') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Fax:
                </label>
                <input
                  type="text"
                  name="fax"
                  v-model="standardApplication.customer.fax"
                  class="orep-text-input w-100"
                >
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>Email:
                </label>
                <input
                  type="email"
                  name="email"
                  autocomplete="email"
                  v-model="standardApplication.customer.email"
                  class="orep-text-input w-100"
                  v-validate="'required|email'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('email')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('email') | filterText }}</span>
              </div>

            </div>
          </div>

        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">2 a.</span>Date firm was established:
          </label>
          <input
            type="text"
            name="dateFirmEstablished"
            v-model="standardApplication.dateFirmEstablished"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('dateFirmEstablished')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('dateFirmEstablished') | filterText }}</span>
          <div style="margin-top: 30px;margin-bottom: 10px;">
          <label for class="orep-label">
            <span class="mr-1">b.</span>Year current owner assumed management:
          </label>

            <input
              type="text"
              name="yearOfOwnerAssumedManagement"
              v-model="standardApplication.yearOfOwnerAssumedManagement"
              class="orep-text-input"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
            >
            <span
              v-show="errors.has('yearOfOwnerAssumedManagement')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('yearOfOwnerAssumedManagement') | filterText }}</span>
          </div>
          <div style="margin-top: 30px;">
          <label for class="orep-label">
            <span class="mr-1">c.</span>Number of years owner licensed
          </label>
          <div class="row" >
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1"></span>As a broker:
              </label>
              <input
                type="text"
                name="yearOfOwnerLicensedAsBroker"
                v-model="standardApplication.yearOfOwnerLicensedAsBroker"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('yearOfOwnerLicensedAsBroker')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('yearOfOwnerLicensedAsBroker') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1"></span>As an agent:
              </label>
              <input
                type="text"
                name="yearOfOwnerLicensedAsAgent"
                v-model="standardApplication.yearOfOwnerLicensedAsAgent"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('yearOfOwnerLicensedAsAgent')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('yearOfOwnerLicensedAsAgent') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1"></span>As an appraiser:
              </label>
              <input
                type="text"
                name="yearOfOwnerLicensedAsAppraiser"
                v-model="standardApplication.yearOfOwnerLicensedAsAppraiser"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('yearOfOwnerLicensedAsAppraiser')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('yearOfOwnerLicensedAsAppraiser') | filterText }}</span>
            </div>
          </div>
          </div>
        </article>


        <article class="input-section form-section">
          <div class="row align-items-center mx-1 pb-0 pt-3">
            <label for class="orep-label mb-0"><span class="mr-1">3.</span>Applicant Ownership: </label>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="llc"
                  value="llc"
                  class="orep-radio"
                  v-validate="'required|included:soleProprietor,llc,partnership,contractor'"
                  @change="validateBeforeSubmit()"
                  v-model="standardApplication.applicantOwnership"
                >
                <span class="radio-span">Corporation/LLC</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="contractor"
                  value="contractor"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="standardApplication.applicantOwnership"
                >
                <span class="radio-span">Independent Contractor</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="soleProprietor"
                  value="soleProprietor"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="standardApplication.applicantOwnership"
                >
                <span class="radio-span">Sole Proprietor</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="partnership"
                  value="partnership"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="standardApplication.applicantOwnership"
                >
                <span class="radio-span">Partnership/LLP</span>
              </label>
            </div>
            <span
              v-show="errors.has('soleProprietor')"
              class="help is-danger form-errors text-danger mt-0 mb-2"
            >{{ errors.first('soleProprietor') | filterText }}</span>
          </div>
        </article>


        <article class="form-heading title-section form-section speical-title-2-wrapper">
          <h2 class="page-title font-weight-bold text-center ">PART 2: STAFF</h2>
          <h4 class="text-center special-title-2">
            Professionals are defined as: Owners, Partners, Officers, Appraisers, Real Estate
Brokers/Agents/Salespersons, Property Managers, OR Consultants, including independent contractors.
          </h4>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">4.</span>Please Indicate the total number of <strong>Professionals</strong>:
          </label>
          <label for class="orep-label">
            <span class="mr-1">a.</span>Number of <strong class="text-underline">Full Time</strong> Professionals (earning more than $20,000):
          </label>
          <input
            type="number"
            name="numberOfFullTimeProfessionals"
            v-model="standardApplication.numberOfFullTimeProfessionals"
            class="orep-text-input w-100"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
            @focus="clearIfZero"
            @blur="restoreIfEmpty"
          >
          <span
            v-show="errors.has('numberOfFullTimeProfessionals')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('numberOfFullTimeProfessionals') | filterText }}</span>
          <div style="margin-top: 30px;margin-bottom: 10px;">
          <label for class="orep-label">
            <span class="mr-1">b.</span>Number of <strong class="text-underline">Part Time</strong> Professionals (earning less than $20,000):
          </label>
          <input
            type="number"
            name="numberOfPartTimeProfessionals"
            v-model="standardApplication.numberOfPartTimeProfessionals"
            class="orep-text-input w-100"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
            @focus="clearIfZero"
            @blur="restoreIfEmpty"
          >
          <span
            v-show="errors.has('numberOfPartTimeProfessionals')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('numberOfPartTimeProfessionals') | filterText }}</span>
          </div>
          <div style="margin-top: 30px">
          <div class="row" >
            <div class="col-md-6">
              <label for class="orep-label mb-0">
                <span class="mr-1">c.</span>Number of Support Staff
              </label>
              <input
                type="text"
                name="numberOfSupportStaff"
                v-model="standardApplication.numberOfSupportStaff"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('numberOfSupportStaff')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('numberOfSupportStaff') | filterText }}</span>
            </div>
            <div class="col-md-6">
              <label for class="orep-label mb-0">
                inactive professionals
              </label>
              <input
                type="text"
                name="numberOfInactiveProfessionals"
                v-model="standardApplication.numberOfInactiveProfessionals"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('numberOfInactiveProfessionals')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('numberOfInactiveProfessionals') | filterText }}</span>
            </div>
          </div>
          </div>
        </article>



        <article class="input-section form-section">
          <div class="row">
            <label for class="orep-label col-md-9 col-sm-12">
              <span class="mr-1">5.</span>
              Does the applicant have a formalized training program for all professionals and staff?
            </label>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="formalizedTrainingProgramProfessionals"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.formalizedTrainingProgramProfessionals"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="formalizedTrainingProgramProfessionals"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.formalizedTrainingProgramProfessionals"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('formalizedTrainingProgramProfessionals')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('formalizedTrainingProgramProfessionals') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">6.</span>Please indicate the number of professional employees who participated in an accredited, continuing
            professional education program during the past 12 months:
          </label>
          <input
            type="text"
            name="numberOfProfessionalsParticipatedEducation"
            v-model="standardApplication.numberOfProfessionalsParticipatedEducation"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('numberOfProfessionalsParticipatedEducation')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('numberOfProfessionalsParticipatedEducation') | filterText }}</span>
        </article>
        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">PART 3: UNDERWRITING INFORMATION</h1>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">7.</span>
                Do at least 15% of all professionals hold a professional designation? (i.e. GRI, CRS, CRE, ABR, MAI, SRA)
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="holdAtLeast15PercentOfAllProfessionals"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.holdAtLeast15PercentOfAllProfessionals"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="holdAtLeast15PercentOfAllProfessionals"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.holdAtLeast15PercentOfAllProfessionals"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('holdAtLeast15PercentOfAllProfessionals')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('holdAtLeast15PercentOfAllProfessionals') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">8.</span>
                Is the applicant owned, associated, or controlled by any business, investment group or syndication?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesApplicantControlInOtherBusiness"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.doesApplicantControlInOtherBusiness"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesApplicantControlInOtherBusiness"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.doesApplicantControlInOtherBusiness"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doesApplicantControlInOtherBusiness')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doesApplicantControlInOtherBusiness') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-12" v-if="standardApplication.doesApplicantControlInOtherBusiness == true || standardApplication.doesApplicantControlInOtherBusiness === 'true'">
            <label for class="orep-label text-danger">
              If Yes, Please provide the name of the entity(s) and the nature of the relationship:
            </label>
          <input
            type="text"
            placeholder="Please explain:"
            class="orep-text-input js-orep-input"
            v-if="standardApplication.doesApplicantControlInOtherBusiness == true || standardApplication.doesApplicantControlInOtherBusiness === 'true'"
            name="doesApplicantControlInOtherBusinessDetails"
            v-model="standardApplication.doesApplicantControlInOtherBusinessDetails"
          >
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="qtn mrpx-5">9 a.</span>Has any member of your firm engaged in property construction or development (including
                renovations)?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="hasAnyMemberEngagedInDevelopment"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.hasAnyMemberEngagedInDevelopment"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="hasAnyMemberEngagedInDevelopment"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.hasAnyMemberEngagedInDevelopment"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('hasAnyMemberEngagedInDevelopment')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('hasAnyMemberEngagedInDevelopment') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-12">
          <p
            class="form-p"
            v-if="standardApplication.hasAnyMemberEngagedInDevelopment === 'true' || standardApplication.hasAnyMemberEngagedInDevelopment == true"
          >If Yes, check all that apply and complete 9b:
          </p>
          <span v-if="standardApplication.hasAnyMemberEngagedInDevelopment === 'true' || standardApplication.hasAnyMemberEngagedInDevelopment == true">
            <label class="orep-label">Please check all that apply</label>
                <div class="radio orep-radio-wrapper">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        class="orep-radio"
                        name="engagedDevelopmentMode"
                        value="directly"
                        v-model="standardApplication.engagedDevelopmentMode"
                      >
                      <span class="radio-span solo-checkbox-span">Directly (member of your firm doing work themselves)</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="engagedDevelopmentMode"
                        value="through-licensed"
                        class="orep-radio"
                        v-model="standardApplication.engagedDevelopmentMode"
                      >
                      <span class="radio-span solo-checkbox-span">Through a licensed contractor</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="engagedDevelopmentMode"
                        value="seprate-entity"
                        class="orep-radio"
                        v-model="standardApplication.engagedDevelopmentMode"
                      >
                      <span class="radio-span solo-checkbox-span">Through a separate business entity owned by any member of your firm or their spouses</span>
                    </label>
                  </div>
                </div>
              </span>
          </div>
          <div class="col-md-12" style="margin-top: 30px">
          <label for class="orep-label">
            <span class="mr-1">b.</span>Provide gross commission income derived from the sale of these properties in the past 12 months, and include this total in
            “Agent/Broker Owned Property Sales” under question 10 on the next page:
          </label>
          <div class="row" >
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1"></span>Residential:
              </label>
              <input
                type="text"
                name="incomeDerivedFromSaleOfResidentialProperties"
                v-model="standardApplication.incomeDerivedFromSaleOfResidentialProperties"
                class="orep-text-input w-100"
                v-validate="standardApplication.incomeDerivedFromSales == true ? 'required': ''"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('incomeDerivedFromSaleOfResidentialProperties')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('incomeDerivedFromSaleOfResidentialProperties') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1"></span>Commercial:
              </label>
              <input
                type="text"
                name="incomeDerivedFromSaleOfCommercialProperties"
                v-model="standardApplication.incomeDerivedFromSaleOfCommercialProperties"
                class="orep-text-input w-100"
                v-validate="standardApplication.incomeDerivedFromSales == true ? 'required': ''"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('incomeDerivedFromSaleOfCommercialProperties')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('incomeDerivedFromSaleOfCommercialProperties') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                <span class="mr-1"></span>
              </label>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="incomeDerivedFromSales"
                    v-model="standardApplication.incomeDerivedFromSales"
                    class="orep-radio"
                    @change="validateBeforeSubmitCheck($event)"
                  >
                  <span class="radio-span solo-checkbox-span">Check here if none in the past 12 months</span>
                </label>
              </div>
            </div>
          </div>
          </div>
          <div class="" style="margin-top: 30px">
            <div class="row">
              <div class="col-md-9 col-sm-12">
                <label for class="orep-label">
                  Are you A Member of a Professional Association?                   </label>
              </div>
              <div class="col-md-3 d-flex flex-column justify-content-center">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                          type="radio"
                          name="professionalAssociation"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.professionalAssociation"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                          type="radio"
                          name="professionalAssociation"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="standardApplication.professionalAssociation"
                      >
                      <span class="radio-span">No</span>
                    </label>
                  </div>
                </div>
                <span
                    v-show="errors.has('professionalAssociation')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('professionalAssociation') | filterText }}</span>
              </div>
            </div>
            <div class="flex wrap">
              <div class="d-flex w-100">
                <div class="col-md-9">
                  <input
                      type="text"
                      class="orep-text-input js-orep-input"
                      placeholder="Please List the Association:"
                      v-if="standardApplication.professionalAssociation === 'true' || standardApplication.professionalAssociation == true"
                      name="professionalAssociationDetails"
                      v-model="standardApplication.professionalAssociationDetails"
                  >
                </div>
              </div>
            </div>
          </div>
          <div  v-if="!this.state.signedInUser" class="" style="margin-top: 30px">
            <div class="row">
              <div class="col-md-9 col-sm-12">
                <label for class="orep-label">
                  Do you have an active E&O policy of your own that is currently in force?                   </label>
              </div>
              <div class="col-md-3 d-flex flex-column justify-content-center">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="noPriorCoverage"
                        :value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="standardApplication.noPriorCoverage"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="noPriorCoverage"
                        :value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="standardApplication.noPriorCoverage"
                      >
                      <span class="radio-span">No</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('noPriorCoverage')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('noPriorCoverage') | filterText }}</span>
              </div>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="radio orep-radio-wrapper solo-checkbox">
            <label>
              <input
                type="checkbox"
                name="emailPolicy"
                class="orep-radio w-40"
                v-model="standardApplication.emailPolicy"
              >
              <span class="radio-span solo-checkbox-span">
                    In lieu of mailing my policy, please Email my policy to the above address. I agree to accept an electronic copy of my application with my policy.
                  </span>
            </label>
          </div>
        </article>

      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-2')"
                :disabled="!state.pageOneIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-3')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-4')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-6')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('standard-application-7')"
                  :disabled="!state.pageSixIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('standard-application-8')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid || !state.pageSevenIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('standard-application-2')">Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {APP_STATUS, STATES} from "../../utils/constants";

export default {
  name: "standard-application-1",
  data() {
    return {
      states: STATES
    };
  },

  computed: {
    standardApplication() {
      return this.$store.state.standardApplication.standardApplication;
    },
    state() {
      return this.$store.state.standardApplication;
    },
    errorMsg() {
      return this.$store.state.standardApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/standard-application-amba/' || this.standardApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/standard-application-realshield/' || this.standardApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    clearIfZero() {
      if (this.standardApplication.numberOfPartTimeProfessionals === 0) {
        this.standardApplication.numberOfPartTimeProfessionals = null;
      }
      if (this.standardApplication.numberOfFullTimeProfessionals === 0) {
        this.standardApplication.numberOfFullTimeProfessionals = null;
      }
    },
    restoreIfEmpty() {
      if (
          this.standardApplication.numberOfPartTimeProfessionals === null ||
          this.standardApplication.numberOfPartTimeProfessionals === ''
      ) {
        this.standardApplication.numberOfPartTimeProfessionals = 0;
      }
      if (
          this.standardApplication.numberOfFullTimeProfessionals === null ||
          this.standardApplication.numberOfFullTimeProfessionals === ''
      ) {
        this.standardApplication.numberOfFullTimeProfessionals = 0;
      }
    },
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.standardApplication.customer.contactName = this.state.standardApplication.nameOfPrimaryLicensed;
      this.standardApplication.customer.companyName = this.state.standardApplication.nameOfApplicant;
      this.standardApplication.customer.isStandardApplication = 'True';
      this.standardApplication.customer.appStatus = APP_STATUS.Partially_Completed;
      if (this.getApplicantType === 'Mercer'){
        this.standardApplication.customer.partnerName = 'Mercer';
      }
      else if (this.getApplicantType === 'Realshield'){
        this.standardApplication.customer.partnerName = 'Realshield';
      }
      this.$store.dispatch('standardApplication/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.standardApplication.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
};
</script>

<style scoped>

</style>
